//src/pages/auth/Login.js
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import GoogleSignIn from "../../components/auth/GoogleSignIn";
import BackgroundWrapper from "../../components/common/BackgroundWrapper";
import "./Auth.css";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);

  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.message;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();

  const from = location.state?.from?.pathname || "/";

  // NORMAL LOGIN ONLY (NO 2FA)
  const onSubmit = async (data) => {
    const response = await login(data);

    if (response.success) {
      navigate(response.isAdmin ? "/admin" : from, { replace: true });
    } else {
      setError("root", { message: response.message });
    }
  };

  return (
    <BackgroundWrapper background="/auth-grid.png">
      <div className="auth-wrapper">
        <div className="auth-card">
          <h2 className="auth-title-small">Welcome Back</h2>
          <p className="auth-subtext">Sign in to your Lilyth account</p>

          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}

          {errors.root && (
            <div className="error-message">{errors.root.message}</div>
          )}

          {/* Google Login */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <GoogleSignIn>
              <button className="google-circle">
                <b>G</b>
              </button>
            </GoogleSignIn>
          </div>

          <p style={{ textAlign: "center" }}>or</p>

          {/* NORMAL LOGIN FORM */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              className="auth-input"
              placeholder="Email"
              type="email"
              {...register("email", { required: "Email is required" })}
            />

            <div className="password-wrapper">
              <input
                className="auth-input"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "Password is required",
                  minLength: { value: 6, message: "Min 6 characters" },
                })}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            {/* Forgot Password */}
            <div className="forgot-password-row">
              <Link to="/forgot-password" className="forgot-password">
                Forgot Password?
              </Link>
            </div>

            <button className="auth-submit" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>

          <div className="auth-footer">
            Don't have an account?{" "}
            <Link to="/register" className="auth-link">
              Register
            </Link>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
};

export default Login;
